module.exports = __webpack_public_path__ + "img/menu-jianmo-active.36bcfd20.svg";